var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pt-1 flex flex-wrap",
      class: _vm.accessories ? "no-pad" : "mb-6",
      attrs: { id: "offer-container" },
    },
    [
      _vm._l(_vm.offersToShow, function (offer_info, offer) {
        return _c(
          "div",
          {
            key: offer,
            class: `w-12/12 flex flex-col justify-start p-1 md:p-2 offer !text-left ${
              offer_info.offerType === _vm.activeOffer.offerType ? "active" : ""
            }`,
            style: `order: ${
              offer_info.offerKey === _vm.activeProductInfo.defaultOffering ||
              offer_info.offerType.includes("Safety")
                ? "-1"
                : "0"
            }`,
            attrs: { value: offer },
            on: {
              click: function ($event) {
                _vm.setActiveOfferKey(offer_info.offerKey)
                _vm.addOffer(offer_info.offerKey)
                _vm.$emit("license-change", offer)
                _vm.scrollTo()
              },
            },
          },
          [
            _c(
              "h4",
              {
                staticClass:
                  "bold text-blue-dark text-2xl mb-1/2 mt-0 leading-none",
              },
              [_vm._v("\n      " + _vm._s(offer_info.offerType) + "\n    ")]
            ),
            _vm._v(" "),
            ["Hardware", "Hardware-B"].includes(offer_info.offerKey)
              ? [
                  _c("p", { staticClass: "mt-0" }, [
                    _vm._v(
                      _vm._s(_vm.currencySymbol.toUpperCase()) +
                        _vm._s(
                          _vm
                            .calculateTotalPrice(
                              _vm.activeProductInfo.offerings[offer].salesPrice
                            )
                            .toFixed(2)
                        )
                    ),
                  ]),
                ]
              : _vm
                  .calculateTotalPrice(
                    _vm.activeProductInfo.offerings[offer].salesPrice
                  )
                  .toFixed(2) !==
                _vm
                  .calculateTotalPrice(
                    _vm.activeProductInfo.offerings[offer].listPrice
                  )
                  .toFixed(2)
              ? [
                  _c("p", { staticClass: "mt-0" }, [
                    _c("span", { staticClass: "line-through" }, [
                      _vm._v(
                        _vm._s(_vm.currencySymbol.toUpperCase()) +
                          _vm._s(
                            _vm
                              .calculateTotalPrice(
                                _vm.activeProductInfo.offerings[offer].listPrice
                              )
                              .toFixed(2)
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", {}, [
                      _vm._v(
                        _vm._s(_vm.currencySymbol.toUpperCase()) +
                          _vm._s(
                            _vm
                              .calculateTotalPrice(
                                _vm.activeProductInfo.offerings[offer]
                                  .salesPrice
                              )
                              .toFixed(2)
                          ) +
                          " / " +
                          _vm._s(
                            _vm.activeProductInfo.offerings[offer]
                              .defaultPaymentTerm
                          )
                      ),
                    ]),
                  ]),
                ]
              : [
                  _c("p", { staticClass: "mt-0" }, [
                    _vm._v(
                      _vm._s(_vm.currencySymbol.toUpperCase()) +
                        _vm._s(
                          _vm
                            .calculateTotalPrice(
                              _vm.activeProductInfo.offerings[offer].salesPrice
                            )
                            .toFixed(2)
                        ) +
                        " / " +
                        _vm._s(
                          _vm.activeProductInfo.offerings[offer]
                            .defaultPaymentTerm
                        )
                    ),
                  ]),
                ],
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-blue-dark font-normal subtext mt-1/2" },
              [_vm._v("\n      " + _vm._s(offer_info.offerSubtext) + "\n    ")]
            ),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _vm.activeOfferKey === "Hardware"
          ? _c("p", { staticClass: "padding-top disclaimer bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.webstoreContent.webstoreBody["hardware_disclaimer"]
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }